const state = {
  items: []
};

const mutations = {
  // SET_USER_ITEMS: (state, payload) => {
  // 	console.log("herer >>> ", payload)
  // 	// state.items = payload.data;
  // 	// const pages = Object.assign(payload.pages, payload.items);
  // 	// state.paging = Object.assign({}, pages);
  // },
  SET_Assign_DATA: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  setAssignData({ commit }, payload) {
    commit("SET_Assign_DATA", payload);
  }
};

const getters = {
  get_Assign_Data: state => state.items
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/module/assignmentOrder.js